import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
      initSliderWhenReady();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}


let swiperThumbs;

function reinintslider() {
  if (swiperThumbs) swiperThumbs.destroy(true, true);

  swiperThumbs = new Swiper(".empty_cart_collaction_swiper", {
    loop: false,
    grabCursor: true,
    spaceBetween: 16,
    slidesPerView: 2.444,
    // slideToClickedSlide: true,
    watchSlidesProgress: true,
    scrollbar: { el: ".swiper-scrollbar" },
    mousewheel: { forceToAxis: true, releaseOnEdges: false, eventsTarget: '.empty_cart_collaction_swiper' },
    breakpoints: { 0: { slidesPerView: 2.001, spaceBetween: 12 }, 750: { slidesPerView: 3.001, spaceBetween: 24 } }
  });
}


function initSliderWhenReady() {
  const checkExist = setInterval(() => {
    const container = document.querySelector(".empty_cart_collaction");
    if (container) {
      reinintslider();
      clearInterval(checkExist); 
    }
  }, 100); 
}